const data = {
  text: 'Jetzt Erstgespräch vereinbaren',
  subline: 'Hier klicken, um Termin zu vereinbaren',
  link: '100 % kostenlos und unverbindlich'
}

export default data
